module.exports = __webpack_public_path__ + "media/application/images/ui/thumbs-up-25a110551d51170424caa549db2078b5.svg";